/**
 * Models used by the Time Switching feature
 */

export enum HoursPerDay {
  NONE = 0,
  ONE = 1, // Default
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  SEVEN = 7,
  EIGHT = 8,
}

export enum DaysPerWeek {
  NONE = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5, // Default
  SIX = 6,
  SEVEN = 7,
}
